/**
 * Application-wide constants.
 * Bot statuses, order statuses, execution modes, polling intervals.
 */

export const BOT_STATUSES = ['RUNNING', 'STOPPED', 'HALTED', 'CRASHED', 'STARTING'] as const;
export type BotStatus = (typeof BOT_STATUSES)[number];

export const ORDER_STATUSES = [
  'PENDING',
  'SUBMITTED',
  'FILLED',
  'PARTIALLY_FILLED',
  'CANCELLED',
  'REJECTED',
  'EXPIRED',
] as const;
export type OrderStatus = (typeof ORDER_STATUSES)[number];

/** Terminal order statuses — no longer active */
export const TERMINAL_ORDER_STATUSES: OrderStatus[] = [
  'FILLED',
  'CANCELLED',
  'REJECTED',
  'EXPIRED',
];

export const EXECUTION_MODES = ['PAPER', 'SHADOW', 'LIVE'] as const;
export type ExecutionMode = (typeof EXECUTION_MODES)[number];

/** Heartbeat is considered stale when > 60s old */
export const BOT_HEARTBEAT_STALE_THRESHOLD_SECONDS = 60;

/** Stale data warning: shown when data is older than 2x polling interval */
export const STALE_DATA_MULTIPLIER = 2;

export const MAX_REASON_LENGTH = 500;
export const MIN_REASON_LENGTH = 1;

export const CONFIRMATION_TOKEN_TTL_SECONDS = 300; // 5 minutes

/** Pagination defaults */
export const DEFAULT_PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100] as const;

/** Date range presets */
export const DATE_RANGE_PRESETS = {
  '7d': 7,
  '30d': 30,
  '90d': 90,
  '1y': 365,
} as const;

export type DateRangePreset = keyof typeof DATE_RANGE_PRESETS;
